// React
import React from 'react'
import PropTypes from 'prop-types'

// Components
import Icon from 'ui/components/Icon'
import BUrlSelect from 'ui/blocks/UrlSelect'

// Shared
import { getIconNameForUrl } from 'ui/components/UrlSelect/utils'

const categoryIcons = {
  products: 'box',
  pages: 'file',
  collections: 'box'
}

const linkIcons = {
  'external-link': 'external-link',
  'phone': 'phone',
  'email': 'envelope'
}

const ValueContainer = (props) => {
  const isLink = props.selectProps?.type === 'link'
  const linkIconName = getIconNameForUrl(props.selectProps?.value?.value)

  const category =
    props.selectProps?.category || props.selectProps?.value?.value?.match(/booqable:\/\/(products)\//)?.[1]

  return (
    <BUrlSelect.Value {...props.innerProps}>
      {!props.hideLinkIcon && isLink && <Icon icon={linkIcons[linkIconName]} />}
      {category && !isLink && <Icon icon={categoryIcons[category]} />}
      {props.children}
    </BUrlSelect.Value>
  )
}

ValueContainer.displayName = 'UrlContainer'

ValueContainer.propTypes = {
  children: PropTypes.node,
  selectProps: PropTypes.shape({
    type: PropTypes.any,
    category: PropTypes.string,
    value: PropTypes.shape({
      value: PropTypes.string
    })
  }),
  hideLinkIcon: PropTypes.bool,
  // This is a prop that react-select passes down to its components
  innerProps: PropTypes.object
}

export default ValueContainer
